// extracted by mini-css-extract-plugin
module.exports = {"header":"diagram_header__F7bLC","diagramWrapper":"diagram_diagramWrapper__nPxfQ","diagramBottomButton":"diagram_diagramBottomButton__MKrGj"};